export default __webpack_public_path__ + "static/media/Dire Greatmane Ale.53047451.jpg";